import React, { useState } from 'react';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';

const SampleCustomModal = () => {
  const [checked, setChecked] = useState(false);
  const handleChange = (e) => setChecked(e.target.checked);
  const placeholderHandleClick = () => alert('accepted!');
  return (
    <>
      <DialogTitle id="responsive-dialog-title">Terms of Service</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please download and review the Service Level Agreement (SLA) which governs the use of the Bringfood platform developed by Applied Geographics, Inc. (AppGeo). By clicking the checkbox below, you as application user, explicitly accept the terms of this SLA.
          &nbsp;
          <a href="https://appgeo.com" rel="noopener noreferrer" target="_blank">Service Agreement PDF</a>
        </DialogContentText>
        <DialogActions>
          <Checkbox
            checked={checked}
            onChange={handleChange}
            inputprops={{ 'aria-label': 'primary checkbox' }}
          />
          I hereby agree to the Terms of Service
        </DialogActions>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={placeholderHandleClick} color="primary" disabled={!checked}>
          Agree
        </Button>
      </DialogActions>
    </>
  );
};

export default SampleCustomModal;
